import { render, staticRenderFns } from "./world-map.vue?vue&type=template&id=51127cce&"
import script from "./world-map.vue?vue&type=script&lang=js&"
export * from "./world-map.vue?vue&type=script&lang=js&"
import style0 from "./_world-map.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports